<main class="max-w-[1400px] bg-blue mx-auto min-h-screen">
    <ng-content></ng-content>
</main>